import React from "react";
import BackendConnectionService from "../../ports/backend/backendConnectionService";
import LocalStorageService from "../../ports/localStorage/localStorageService";
import Toastify from "../../components/alerts/Toastify";
import {toast} from "react-toastify";
import ResponseProcessorService from "../../ports/backend/ResponseProcessorService";

export default class PasswordChangeForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPass: null,
            newPass: null,
            newPassRepeat: null,
            message: null,
            type: null,
            changing: false
        }
    }

    attemptPassChange() {
        let {currentPass, newPass, newPassRepeat} = this.state;
        if(newPass !== newPassRepeat) {
            Toastify.error(toast, "Las contraseñas no coinciden.")
        } else if(newPass === "" || newPassRepeat === "" || currentPass === "" || newPass === null || newPassRepeat === null || currentPass === null) {
            Toastify.error(toast, "No se permiten campos vacíos.");
        } else {
            this.setState({
                currentPass: "",
                newPass: "",
                newPassRepeat: "",
                changing: true
            });
            let token = LocalStorageService.getUserToken();
            BackendConnectionService.changePassword(token, currentPass, newPass).then((e) => {
                Toastify.success(toast, "La contraseña se ha cambiado correctamente.");
            }).catch((e) => {
                ResponseProcessorService.processError(e);
            }).finally(() => {
                this.setState({ changing: false });
            });
        }
    }

    currentPassword(value) {
        this.setState({
            currentPass: value
        });
    }

    newPassword(value) {
        this.setState({
            newPass: value
        });
    }

    confirmPassword(value) {
        this.setState({
            newPassRepeat: value
        });
    }

    render() {
        let {currentPass, newPass, newPassRepeat, changing} = this.state;
        if(currentPass === undefined || currentPass == null) currentPass = "";
        if(newPass === undefined || newPass == null) newPass = "";
        if(newPassRepeat === undefined || newPassRepeat == null) newPassRepeat = "";
        let boton = (<button
            className="btn btn-success btn-block waves-effect waves-light"
            type="button" onClick={() => {this.attemptPassChange()}}>Cambiar contraseña
        </button>);
        if (changing) {
            boton = (<button
                className="btn btn-success btn-block waves-effect waves-light"
                type="button" disabled>Cambiando...
            </button>);
        }

        return (
            <div className="card">
                <div className="card-body p-4">
                    <div className="p-2">
                        <h5 className="mb-5 text-center">Cambiar contraseña de administración</h5>
                        <form>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group mb-4">
                                        <label htmlFor="current">Contraseña actual</label>
                                        <input type="password" className="form-control" id="current"
                                                placeholder="********" value={currentPass} onChange={(e) => this.currentPassword(e.target.value)} />
                                    </div>
                                    <div className="form-group mb-4">
                                        <label htmlFor="new">Nueva contraseña</label>
                                        <input type="password" className="form-control" id="new"
                                                placeholder="********" value={newPass} onChange={(e) => this.newPassword(e.target.value)} />
                                    </div>
                                    <div className="form-group mb-4">
                                        <label htmlFor="confirm">Repita la contraseña</label>
                                        <input type="password" className="form-control" id="confirm"
                                                placeholder="********" value={newPassRepeat} onChange={(e) => this.confirmPassword(e.target.value)} />
                                    </div>

                                    <div className="mt-4">
                                        {boton}
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}